import { render } from "./FinalRound.vue?vue&type=template&id=4543401a"
import script from "./FinalRound.vue?vue&type=script&lang=js"
export * from "./FinalRound.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__